import { Info } from "lucide-react";
import Loading from "../../shared/Loading";

const PromptDeleteRole = ({
  closePromptDeleteRole,
  handleContinueDeleting,
  loading,
}) => {
  return (
    <div
      onClick={(e) => {
        closePromptDeleteRole();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <Info size={40} color="#F4A261" />
        <p className="text-[#5C5C5C] text-center text-[16px] font-semibold">
          WARNING
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal text-center">
          Please confirm you want to delete the role. Proceeding will record
          your decision.
        </p>
        <div className="flex items-center mt-[20px] justify-center gap-[10px]">
          <button
            onClick={closePromptDeleteRole}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Cancel
          </button>
          <button
            disabled={loading}
            onClick={handleContinueDeleting}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptDeleteRole;
